<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card v-if="currentFormMobile">
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать форму</h2>
          </div>
          <div class="column" v-else>
            <h2 class="title is-3">Изменить форму: {{ currentFormMobileName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="currentFormMobile.name_for_people"></b-input>
            </b-field>

            <b-field label="Название для Firebase">
              <b-input v-model="currentFormMobile.name"></b-input>
            </b-field>

            <div v-if="currentFormMobile.user_access">
              <v-divider/>
              <label class="label">Доступы</label>

              <b-field class="mt-4" label="Все пользователи">
                <b-switch
                  @input="onAllUsersChange"
                  v-model="currentFormMobile.user_access.all">
                  {{ currentFormMobile.user_access.all ? 'Да' : 'Нет' }}
                </b-switch>
              </b-field>

              <div v-if="!currentFormMobile.user_access.all">
                <p class="error--text">Когда выбираете человека в группах пользователей, доступ будет у него и ВСЕЙ ЕГО КОМАНДЫ</p>

                <v-select
                  outlined
                  v-model="currentFormMobile.user_access.subordinates_of"
                  label="Группы пользователей"
                  :items="teamleads"
                  item-value="id"
                  item-text="name"
                  multiple
                  class="mt-7"
                ></v-select>

                <v-select
                  class="mb-3"
                  outlined
                  v-model="currentFormMobile.user_access.users"
                  label="Пользователи"
                  :items="profiles"
                  item-value="id"
                  item-text="name"
                  multiple
                ></v-select>
              </div>
              <v-divider/>
            </div>


            <!-- ПОЛЯ И ЗНАЧЕНИЯ ПО УМОЛЧАНИЮ -->
            <div>
              <div
                class="mt-6"
                style="
                align-items: end;
                display: flex;
                flex-direction: column;"
              >
                <b-button @click="addField" type="is-primary" size="is-small">
                  Добавить поле
                </b-button>
              </div>

              <b-field label="Поля" required>
                <b-table :data="currentFormMobile.fields" :striped="true" :hoverable="true">
                  <b-table-column field="name" label="Имя поля">
                    <template v-slot="props">
                      <b-input
                        v-model="props.row.name"
                        placeholder="Введите имя поля"
                        required
                      ></b-input>
                    </template>
                  </b-table-column>

                  <b-table-column field="type" label="Тип поля">
                    <template v-slot="props">
                      <b-select v-model="props.row.type">
                        <option value="id">ID</option>
                        <option value="image">Image</option>
                        <option value="link">Link</option>
                        <option value="show">Show</option>
                        <option value="string">String</option>
                        <option value="number">Number</option>
                        <option value="bool">Boolean</option>
                        <option value="timestamp">Timestamp</option>
                      </b-select>
                    </template>
                  </b-table-column>

                  <b-table-column field="default_value" label="По умолчанию">
                    <template v-slot="props">
                      <!-- Для типа number используем input type="number" -->
                      <b-input
                        v-if="props.row.type === 'number'"
                        v-model="props.row.default_value"
                        type="number"
                        required
                      ></b-input>

                      <!-- Для типа bool и show используем тройной чекбокс -->
                      <div v-else-if="props.row.type === 'bool' || props.row.type === 'show'" class="tri-state-checkbox">
                        <b-button
                          type="is-text"
                          @click="toggleTriState(props.row)"
                          :class="{
                            'has-text-grey': props.row.default_value === null || props.row.default_value === '',
                            'has-text-success': props.row.default_value === true,
                            'has-text-danger': props.row.default_value === false
                          }"
                        >
                          <b-icon
                            :icon="getTriStateIcon(props.row.default_value)"
                            :class="{
                              'has-text-grey': props.row.default_value === null || props.row.default_value === '',
                              'has-text-success': props.row.default_value === true,
                              'has-text-danger': props.row.default_value === false
                            }"
                          ></b-icon>
                          <span class="ml-2">{{ getTriStateText(props.row.default_value) }}</span>
                        </b-button>
                      </div>

                      <!-- Для типов image и id скрываем поле -->
                      <div v-else-if="props.row.type === 'image' || props.row.type === 'id'">
                        <span class="has-text-grey-light">Не требуется</span>
                      </div>

                      <!-- Для остальных типов используем обычный input -->
                      <b-input
                        v-else
                        v-model="props.row.default_value"
                        required
                      ></b-input>
                    </template>
                  </b-table-column>

                  <b-table-column label="Действия">
                    <template v-slot="props">
                      <b-button @click="removeField(props.row)" type="is-danger" size="is-small">
                        Удалить
                      </b-button>
                    </template>
                  </b-table-column>
                </b-table>
              </b-field>
            </div>

          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" v-if="isCreate" @click="createForm()">Добавить</v-btn>
        <v-btn text color="primary" v-else @click="updateForm()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'FormMobileDetailsModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      currentFormMobileName: '',
    };
  },
  created() {
    this.getProfiles();
    this.getTeamLeads();
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentFormMobileName = this.currentFormMobile.name;
      }
    },
  },
  computed: {
    profiles: {
      get() {
        return this.$store.getters.GET_PROFILES;
      },
      set(value) {
        this.$store.commit("SET_PROFILES", value);
      },
    },
    teamleads() {
      return this.$store.getters.GET_TEAMLEAD_DATA;
    },
    isCreate() {
      return this.currentFormMobile && this.currentFormMobile.id == null;
    },
    isLoading: {
      get() {
        return this.$store.getters.GET_FORM_MOBILE_DETAILS_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit("SET_FORM_MOBILE_DETAILS_MODAL_LOADING", value);
      },
    },
    isOpen: {
      get() {
        return this.$store.getters.GET_FORM_MOBILE_DETAILS_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit('SET_FORM_MOBILE_DETAILS_MODAL_OPENED', value);
      },
    },
    currentFormMobile: {
      get() {
        return this.$store.getters.GET_CURRENT_FORM_MOBILE;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_FORM_MOBILE", value);
      },
    },
  },
  methods: {
    onAllUsersChange() {
      if (this.currentFormMobile.user_access.all) {
        this.currentFormMobile.user_access.users = [];
        this.currentFormMobile.user_access.subordinates_of = [];
      }
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentFormMobile = {'fields': [], 'user_access': {'all': true}};
      this.isOpen = false;
      this.isLoading = false;
    },
    createForm() {
      this.$store.dispatch('CREATE_FORM_MOBILE', this.currentFormMobile)
        .then(() => {
          this.$toast.success("Форма создана!");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при создании формы");
        });
    },
    updateForm() {
      let data = {
        id: this.currentFormMobile.id,
        form: this.currentFormMobile
      }
      this.$store.dispatch('UPDATE_FORM_MOBILE', data)
        .then(() => {
          this.$toast.success("Форма успешно изменена!");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при изменении формы");
        });
    },
    getProfiles() {
      this.loading = true;
      const params = {
        filters: {},
        type: 'SET_PROFILES',
      };
      this.$store
        .dispatch("GET_PROFILES", params)
        .then((data) => {
        })
        .catch((error) => {
          this.$toast.error("Неизвестная ошибка!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTeamLeads() {
      this.loading = true;
      const params = {
        filters: { role: 'teamlead', status: 'true' },
        type: 'SET_TEAMLEADS',
      };
      this.$store
        .dispatch("GET_PROFILES", params)
        .then((data) => {})
        .catch((error) => {
          this.$toast.error("Неизвестная ошибка!");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // для полей
    getTriStateText(value) {
      if (value === true) return 'Да';
      if (value === false) return 'Нет';
      return 'Не задано';
    },
    getTriStateIcon(value) {
      if (value === true) return 'check';
      if (value === false) return 'close';
      return 'minus';
    },
    toggleTriState(field) {
      if (field.default_value === true) {
        field.default_value = false;
      } else if (field.default_value === false) {
        field.default_value = null;
      } else {
        field.default_value = true;
      }
    },

    addField() {
      // Добавляет новое поле с пустым именем и типом 'string' по умолчанию
      this.currentFormMobile.fields.push({
        name: '',
        type: 'string',
        default_value: ''
      });
    },
    removeField(field) {
      const index = this.currentFormMobile.fields.indexOf(field);
      if (index > -1) {
        this.currentFormMobile.fields.splice(index, 1);
      }
    },
  },
};
</script>

<style>
.full-width-upload {
  width: 100%;
  display: block;
}

.full-width-upload .section {
  width: 100%;
}

.full-width-upload .content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
